/* PERF: runs the inline scripts that were held back with type="text/ts-defer" (see snippets/ts-defer-attr).
   Loaded with defer right after the deferred jQuery, so it executes once jQuery, custom-jtpl.js and
   jquery.products are ready and before DOMContentLoaded ($(document).ready handlers still fire as before).
   Each script is re-inserted as a normal inline script, so it runs in global scope (functions and vars it
   declares stay global, as onclick handlers expect) and in the same order it appears in the page.
   An error in one script is reported in the console and does not stop the others. */
(function () {
  var held = document.querySelectorAll('script[type="text/ts-defer"]');
  for (var i = 0; i < held.length; i++) {
    var old = held[i];
    var s = document.createElement('script');
    for (var a = 0; a < old.attributes.length; a++) {
      var at = old.attributes[a];
      if (at.name !== 'type') s.setAttribute(at.name, at.value);
    }
    s.text = old.text;
    old.parentNode.replaceChild(s, old);
  }
})();
